export const getHsCalling = () => {
  let hsCalling = {
    addEventListener: () => void 0,
    removeEventListener: () => void 0,
    triggerEvent: () => void 0
  };
  try {
    if (window.top && window.top.hsCalling && window.top.hsCalling.addEventListener && typeof window.top.hsCalling.addEventListener === 'function' && window.top.hsCalling.removeEventListener && typeof window.top.hsCalling.removeEventListener === 'function') {
      hsCalling = window.top.hsCalling;
    }
  } catch (e) {
    // Do nothing
  }
  return hsCalling;
};